import { NgModule, Component, Input, Output, ChangeDetectionStrategy, ViewChild, ChangeDetectorRef, EventEmitter } from '@angular/core';
import { isPlatformBrowser, isPlatformServer, Location } from '@angular/common'
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { Observable } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';

@Component({
    selector: 'vdgm-select',
    template:`
        <ng-container>
            <select class="form-control" [(ngModel)]="selectedValue" (change)="onSelect.emit(selectedValue)" >
                <option *ngFor="let option of items" [ngValue]="option">{{option.meta.title}}</option>
            </select>            
            <span class="picker">{{(selectedValue|meta).title}}<i class="icon cntv-arrow-down"></i></span>
        </ng-container>
    `,
    styleUrls: ['vdgm-select.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VdgmSelect {
    @Input() items: Array<any> = [];
    @Output() onSelect:EventEmitter<any> = new EventEmitter<any>();
    @Input() selectedValue:any;
    
    /**
     * SeriesSpotlight component
     */
    constructor(private coreEffects: CoreEffects, private cd: ChangeDetectorRef, ) {
    }
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/series/vdgm-select/vdgm-select.component.ts